// React Imports
import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Lodash
import _ from 'lodash';

// I18n
import { I18n } from 'react-redux-i18n';

import {
  Heading,
  Switch,
  Dialog,
} from '@adobe/react-spectrum';

// Redux Actions
import { addSingleFilter, removeSingleFilter } from '../../actions/filterActions';

// Styles
import '../../styles/FilterCommon.scss';
import '../../styles/ToggleFilter.scss';
import { withRouter } from '../withRouter';

const PartnerAwardsToggleFilter = ({ router }) => {
  // Redux and router hooks
  const dispatch = useDispatch();
  const appliedFilters = useSelector((state) => state.filter.selected);

  // Handle toggle switch
  const handleToggleSwitch = (e) => {
    if (e) {
      dispatch(addSingleFilter({ name: 'badges', value: true }, router));
    } else {
      dispatch(removeSingleFilter({ name: 'badges' }, router));
    }
  };

  // Render the toggle filter for desktop
  const renderToggleFilter = () => {
    const selected = _.has(appliedFilters, 'badges');
    return (
      <Dialog UNSAFE_className="toggle-filter-dialog">
        <div className="dropdown-upper-section">
          <Switch
            aria-label={I18n.t('partner_finder.filters.accredited_solutions_label')}
            isEmphasized
            UNSAFE_className="toggle-switch"
            isSelected={selected}
            onChange={handleToggleSwitch}
          />
          <Heading UNSAFE_className="dropdown-title">
            Only show Partner Award winners
          </Heading>
        </div>
      </Dialog>
    );
  };

  return (
    <div className="cmp-toggleFilter" id="accredited-filter">
      {renderToggleFilter()}
    </div>
  );
};

PartnerAwardsToggleFilter.propTypes = {
  appliedFilters: PropTypes.shape({
    badges: PropTypes.bool,
  }),
  router: PropTypes.shape({}).isRequired,
};

PartnerAwardsToggleFilter.defaultProps = {
  appliedFilters: {},
};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  appliedFilters: state.filter.selected,
});

const mapDispatchToProps = {
  addSingleFilterAction: addSingleFilter,
  removeSingleFilterAction: removeSingleFilter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerAwardsToggleFilter));
